import React from "react";
import type { CampaignContactStatus } from "@/model/interface/CampaignContact";

const LABEL_BY_STATUS: Record<string, string> = {
  QUEUED: "Queued",
  DIALING: "Dialing",
  RINGING: "Ringing",
  ANSWERED: "Answered",
  CONNECTED: "On call",
  ON_HOLD: "On hold",
  COMPLETED: "Completed",
  NO_ANSWER: "No answer",
  BUSY: "Busy",
  SKIPPED: "Skipped",
  SUPPRESSED: "Suppressed",
  CANCELED: "Canceled",
  VOICEMAIL: "Voicemail",
  ABANDONED: "Abandoned",
  FAILED: "Failed",
};

export function statusLabel(status: CampaignContactStatus): string {
  return LABEL_BY_STATUS[status] ?? status;
}

export function StatusLabel({ status }: { status: CampaignContactStatus }) {
  return <span className="text-sm text-muted-foreground">{statusLabel(status)}</span>;
}
